export default function ($) {

    zE(function() {
        setTimeout(() => {
        zE('webWidget', 'updateSettings', {
            contactForm: {
            fields: [
                { id: 21691574303772, prefill: {'*': 'Gilbert Online'} },
                { id: 23083703356444, prefill: {'*': 'https://www.laboratoires-gilbert.com/fr/politique-de-confidentialite'} }
            ]
            }
        });
        }, 5400);
    });

    zE('webWidget:on', 'open', function() {	
        setTimeout(() => {
            // Récupérer l’iframe du widget
            const iframe = document.querySelector('iframe#webWidget');

            if (!iframe) return;
            const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;
            if (!iframeDoc) return;

            // Champs du forumulaire
            const piecesJointes = iframeDoc.querySelector('[id="dropzone-input"]').parentElement.parentElement;
            const mentionRgpd = iframeDoc.querySelector(`[data-fieldid="key:25161030618140"]`).parentElement.parentElement;
            const texteMentionRgpd = mentionRgpd.firstElementChild.firstElementChild;
            const textareaMentionRgpd = iframeDoc.querySelector('[name="key:25161030618140"]');
            const politiqueConfidentialite = iframeDoc.querySelector(`[data-fieldid="key:23083703356444"]`).parentElement.parentElement;
            const societe = iframeDoc.querySelector(`[data-fieldid="key:21691574303772"]`).parentElement.parentElement;
            const subject = iframeDoc.querySelector('[name="key:25098411105052"] div');
            const message = iframeDoc.querySelector('label[data-fieldid="description"] strong');
            const message_info = document.createElement('small');

            // Affichage de la phrase RGPD en HTML
            politiqueConfidentialite.style.display = 'none';
            societe.style.display = 'none';
            piecesJointes.after(mentionRgpd);
            texteMentionRgpd.style.display = 'none';
            texteMentionRgpd.nextElementSibling.innerHTML = texteMentionRgpd.nextElementSibling.textContent;
            textareaMentionRgpd.style.display = 'none';

            const observer = new MutationObserver((mutations) => {
                mutations.forEach(() => {
                    const fileds_ary = ['[name="name"]', '[name="email"]', '[name="description"]'];
                    //Remise à zéro de certains champs modifiés
                    message.textContent = 'Votre message';
                    message_info.textContent = "";
                    piecesJointes.firstElementChild.firstElementChild.textContent = "Pièces jointes";

                    if (subject.innerHTML == "Où trouver nos produits ?" || subject.innerHTML == "Candidature") {
                        const textareaPDV = iframeDoc.querySelector('[name="key:25101554088732"]');
                        const phrasePDV = iframeDoc.querySelector('[data-fieldid="key:25101554088732"] + div');
                        const textareaCandidature = iframeDoc.querySelector('[name="key:25162826013340"]');
                        const phraseCandidature = iframeDoc.querySelector('[data-fieldid="key:25162826013340"] + div');
                        const footer = iframeDoc.querySelector('footer');
                        const submitBouton = iframeDoc.querySelector('button[type="submit"]');

                        if (subject.innerHTML == "Où trouver nos produits ?") {
                            textareaPDV.style.display = 'none';
                            phrasePDV.innerHTML = phrasePDV.textContent;
                        } 
                        if (subject.innerHTML == "Candidature") {
                            textareaCandidature.style.display = 'none';                         
                            phraseCandidature.innerHTML = phraseCandidature.textContent;
                        } 
                        fileds_ary.forEach(element => {
                            iframeDoc.querySelector(element).parentElement.style.display = 'none';
                        });

                        // Pièces jointes
                        piecesJointes.style.display = 'none';

                        // Bouton submit
                        footer.style.display = 'none';
                        submitBouton.disabled = true;

                        // Phrase RGPD vide
                        mentionRgpd.style.display = 'none';  

                    } else {
                        const marque = iframeDoc.querySelector('[name="key:25098106806684"] div');
                        
                        if(subject.innerHTML == "Information produit" || subject.innerHTML == "Réclamation qualité produit" || subject.innerHTML == "Déclarer un effet indésirable") {
                            const observerMarque = new MutationObserver((mutationsMarque) => {
                                mutationsMarque.forEach(() => {
                                    if(marque.innerHTML == "Physiolac" ) {
                                        const divForm = iframeDoc.querySelector('main div').nextElementSibling;
                                        divForm.style.display = 'none';
                                        const btnFormulairePhysiolac = document.createElement('div');
                                        btnFormulairePhysiolac.innerHTML = '<p><strong>Pour contacter le Service Consommateurs Physiolac, veuillez cliquer sur le lien ci-dessous : </strong></p><br/><p><a href="https://www.laboratoires-gilbert.com/fr/formulaire-physiolac/" target="_top"> Formulaire de contact Physiolac</a></p>';
                                        divForm.after(btnFormulairePhysiolac);
                                        iframeDoc.querySelector('footer').style.display = 'none';
                                        iframeDoc.querySelector('button[type="submit"]').disabled = true;
                                    }
                                });
                            });
                            observerMarque.observe(marque, {
                                childList: true,
                                subtree: true,
                                characterData: true
                            });
                        }
                        if(subject.innerHTML == "Déclarer un effet indésirable") {
                            iframeDoc.querySelector('[name="key:6281144935580"]').style.display = 'none';
                            iframeDoc.querySelector(`[data-fieldid="key:6281144935580"]`).style.display = 'none';
                            message.textContent = 'Effet indésirable ressenti ou observé';
                            message_info.textContent = ' (Merci d’envoyer votre message en français ou anglais pour la bonne prise en charge de votre demande.)';
                            message.after(message_info);
                            piecesJointes.firstElementChild.firstElementChild.textContent = "Pièces jointes : photos de la réaction, compte-rendu médical... (facultatif)";
                        }
                        if(subject.innerHTML == "Réclamation qualité produit") {
                            message.textContent = 'Descriptif de l’anomalie rencontrée';
                            message_info.textContent = ' (Merci d’envoyer votre message en français ou anglais pour la bonne prise en charge de votre demande.)';
                            message.after(message_info);
                            piecesJointes.firstElementChild.firstElementChild.textContent = "Pièces jointes (photos du produit concerné)";
                        }
                        fileds_ary.forEach(element => {
                            iframeDoc.querySelector(element).parentElement.style.display = 'block';
                        });
                        piecesJointes.style.display = 'block';
                        iframeDoc.querySelector('footer').style.display = 'block';
                        iframeDoc.querySelector('button[type="submit"]').disabled = false;
                        mentionRgpd.style.display = 'block';
                    }
                });
            });    
            observer.observe(subject, {
                childList: true,
                subtree: true,
                characterData: true
            });

        }, 1200); // délai pour laisser le widget charger);
    });

}
